import React, { useMemo } from "react";
import { AddChild } from "./AddChild";
import { HtmlElement } from "./HtmlElement";
import { TextElement } from "./TextElement";
import { emptyArray } from "../../../../redux/utils";

export const ArrayElement = ({arr, path, acceptElements, acceptText}) => {

  const elements = useMemo(() => {
    console.log("rehaciendo arrayElement", {arr, path, acceptElements, acceptText})
    if(!arr || arr.length === 0) {
      return <AddChild acceptElements={acceptElements} acceptText={acceptText} path={path} index={!!arr ? arr.length : 0}/>
    }
    return [...(arr || emptyArray).map((element, index) => {
        return (
          <div key={`${JSON.stringify(element)}.${path}.${index}`}>
            <AddChild acceptElements={acceptElements} acceptText={acceptText} path={path} index={index} />
            {element.node === "element" &&
              <HtmlElement key={`${path}.${index}`} path={`${path}.${index}`} element={element} />
            }
            {element.node === "text" && 
              <TextElement key={`${path}.${index}`} path={`${path}.${index}`} element={element} />
            } 
            {index === arr.length - 1 &&
              <AddChild acceptElements={acceptElements} acceptText={acceptText} path={path} index={!!arr ? arr.length : 0}/>
            }
          </div>
        )
      }),
    ]
  }, [arr, path, acceptElements, acceptText]);

  return (
    <div className="vhe-array-element">
      {elements}
    </div>
  )
}